module.exports = __webpack_public_path__ + "img/microsoft-art-of-work-laptop.9d573a05.png";